import { push } from 'connected-react-router'
import { CALL_API } from '../../util/RBRestMiddleware'

/// /////////////////// USERNAME ACTIONS///////////////////////////
export const FETCH_USERNAME_LOADING = 'FETCH_USERNAME_LOADING'
export const FETCH_USERNAME_SUCCESS = 'FETCH_USERNAME_SUCCESS'
export const FETCH_USERNAME_FAILED = 'FETCH_USERNAME_FAILED'

export const HANDLE_PREV = 'HANDLE_PREV'

export const handlePrev = () => {
  return {
    type: HANDLE_PREV
  }
}

// Errors//
export const fetchUsername = (userName) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/account/forgotPassword',
        prefix: 'FETCH_USERNAME',
        query: { 'userName': userName },
        method: 'post'
      }
    })
  }
}

// export const fetchUsername = (userName) => {
//   return function (dispatch) {
//     dispatch(checkUsername())

//     // make a request to the API server
//     ApiHelper.makeRequest(
//       // send the dispatch object as it's used in the helper
//       dispatch,
//       // set the path of the url request
//       '/account/forgotPassword',
//       // set the HTTP method of POST,PUT,GET etc
//       'post',
//       // set the body for the request, just send object and not a JSON string
//       { 'userName': userName },
//       // the function to run if the request is successful
//       function (json) {
//         // handle success
//         dispatch(receiveUsername(json))
//       },
//       // the action to run if there is an error
//       function (error) {
//         // handle httperror
//         dispatch(failedUsername(error))
//       })
//   }
// }

/// /////////////// SECCURITY ACTIONS///////////////////////

export const CHECK_ANSWER_LOADING = 'CHECK_ANSWER_LOADING'
export const CHECK_ANSWER_SUCCESS = 'CHECK_ANSWER_SUCCESS'
export const CHECK_ANSWER_FAILED = 'CHECK_ANSWER_FAILED'

// export const CHECK_ANSWER = 'CHECK_ANSWER'
// export const checkAnswer = () => {
//   return {
//     type: CHECK_ANSWER
//   }
// }

// export const RECEIVE_ANSWER = 'RECEIVE_ANSWER'

// export const receiveAnswer = () => {
//   return {
//     type: RECEIVE_ANSWER
//   }
// }

// // Error Messages//

// export const ANSWER_FAILED = 'ANSWER_FAILED'

// export const failedSecurityAnswer = (error) => {
//   return {
//     type: ANSWER_FAILED,
//     error
//   }
// }

export const checkSecurityAnswer = (userName, question, SecurityAnswer) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/account/forgotPasswordAnswer',
        prefix: 'CHECK_ANSWER',
        query: { 'userName': userName, 'question': question, 'answer': SecurityAnswer },
        method: 'post',
        onSuccess: () => {
          dispatch(push('/RetrievePassword'))
        }
      }
    })
  }
}

// export const checkSecurityAnswer = (userName, question, SecurityAnswer) => {
// return function (dispatch) {
//   dispatch(checkAnswer())

//   // make a request to the API server
//   ApiHelper.makeRequest(
//     // send the dispatch object as it's used in the helper
//     dispatch,
//     // set the path of the url request
//     '/account/forgotPasswordAnswer',
//     // set the HTTP method of POST,PUT,GET etc
//     'post',
//     // set the body for the request, just send object and not a JSON string
//     { 'userName': userName, 'question': question, 'answer': SecurityAnswer },
//     // the function to run if the request is successful
//     function () {
//       // handle success
//       dispatch(receiveAnswer())
//       dispatch(push('/RetrievePassword'))
//     },
//     // the action to run if there is an error
//     function (error) {
//       // handle httperror
//       dispatch(failedSecurityAnswer(error))
//     })
// }
// }



// WEBPACK FOOTER //
// ./src/redux/actions/forgotPasswordActions.js